import gql from 'graphql-tag';

import type { LongFormProjectFields } from 'src/data/longForm';
import { executeGqlQuery, type GqlCallVariables } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_LONG_FORM_BUILDER_DRAFT, FRAGMENT_LONG_FORM_BUILDER_PROJECT } from './schema';

const QUERY = gql`
  query ProjectLongFormData($projectId: Int!, $draftIndex: ID) {
    project(id: $projectId) {
      id
      longForm {
        generationTool
        localizedLanguages
      }
      longFormBuilderProject(longFormBuilderDraftId: $draftIndex) {
        ...LongFormBuilderProject
      }
      longFormBuilderDrafts {
        ...LongFormBuilderDraft
      }
    }
  }
  ${FRAGMENT_LONG_FORM_BUILDER_PROJECT}
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
`;

interface Variables extends GqlCallVariables {
  projectId: ID;
  draftIndex?: string;
}

interface Options {
  abortSignal?: AbortSignal;
}

export const queryProjectLongFormData = async (
  variables: Variables,
  options: Options
): Promise<LongFormProjectFields | undefined> => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  return getSingleProp<LongFormProjectFields>(result.data);
};
